import { apiFetch } from './client';

export function fetchMarketingHealth() {
  return apiFetch('/api/marketing/health');
}
